<template>
  <section>
    <Modal
      :title="telemetryData.isLoading ? 'Telemetry Inspector' : 'Telemetry Inspector (' + telemetryData.data.payload_transmission.upstream_dev_id + ')'"
      :background-primary="true"
      button-icon-pack="fas"
      button-icon="broadcast-tower"
      button-text="Gateways"
      @close="$parent.close()"
      @click="isGatewayInspectorActive = !isGatewayInspectorActive"
    >
      <div class="is-telemetryinspector-modal">
        <div class="modal-card is-page-modal">
          <b-loading
            :is-full-page="false"
            :active.sync="telemetryData.isLoading"
            :can-cancel="false"
          />
          <h1
            class="subtitle is-5"
            style="margin-top: 1rem;"
          >
            Raw device JSON
          </h1>
          <span
            class="notification is-7 subtitle telemetry-json-view"
          >{{ telemetryData.data.payload }}</span>
          <h1 class="subtitle is-5">
            Raw metadata JSON
          </h1>
          <span
            class="notification is-7 subtitle telemetry-json-view"
          >{{ telemetryData.data.payload_transmission }}</span>
        </div>
      </div>
    </Modal>
    <b-modal
      :active.sync="isGatewayInspectorActive"
      :can-cancel="true"
      has-modal-card
    >
      <GatewayInspectorComponent :data="telemetryData.data" />
    </b-modal>
  </section>
</template>

<script>
import TelemetryApi from "@/services/Telemetry";
import Modal from "@/components/elements/Modal.vue";
import GatewayInspectorComponent from "@/components/GatewayInspector";
import { mapActions } from "vuex";

export default {
  name: "TelemetryInspector",
  components: {
    Modal,
    GatewayInspectorComponent,
  },
  props: {
    uuid: String,
  },
  data() {
    return {
      isGatewayInspectorActive: false,
      telemetryData: {
        data: [],
        isEmpty: true,
        isLoading: true,
      },
    };
  },
  methods: {
    ...mapActions({
      throwGlobalNotification: "throwGlobalNotification",
    }),
    getTelemetryData() {
      this.telemetryData.isLoading = true;
      TelemetryApi.telemetryData(this.uuid)
        .then((response) => {
          if (response != null) {
            this.telemetryData.data = response;
            this.telemetryData.isEmpty = false;
          }
          this.telemetryData.isLoading = false;
        })
        .catch((err) => {
          this.throwGlobalNotification({
            message: "An error has occurred: " + err.name,
            queue: false,
            isError: true,
          });
          this.telemetryData.isLoading = false;
        });
    },
  },
  mounted() {
    this.getTelemetryData();
  },
};
</script>

<style lang="scss">
.telemetry-json-view {
  margin-bottom: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.is-telemetryinspector-modal {
  height: 24rem;
  min-width: 50rem;
  width: auto;
  overflow-y: auto;
}
</style>